import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import about2 from "../assets/img/about-2.png";
import about3 from "../assets/img/about-3.png";
import { Link } from "react-router-dom";
const Homenew = () => {
  useEffect(() => {
    AOS.init({ duration: 1000 });
  }, []);
  return (
    <div>
      <div className="law-section container-fluid">
        {/* --- First Row --- */}
        <div className="row align-items-center" data-aos="fade-up">
          {/* Left Content */}
          <div className="col-lg-6 mb-4 mb-lg-0 px-md-5">
            <div className="px-md-5">
              <h2 className="law-section-heading px-md-2">
                Redevelopment & Self-Redevelopment Consultancy
              </h2>
              <p className="mt-3 text-secondary px-md-2">
                The Firm is presently engaged in multiple high-value
                redevelopment and self-redevelopment projects across
                Maharashtra, offering comprehensive legal consultation,
                structuring, and regulatory guidance.
              </p>
              <Link
                to="/litigation"
                className="read-more-btn1 mt-3"
              >
                Learn More
              </Link>
            </div>
          </div>
          {/* Right Image */}
          <div className="col-lg-6 text-center p-0">
            <img
              src={about2}
              alt="Law Image 1"
              className="img-fluid hover-effect"
            />
          </div>
        </div>
        {/* --- Second Row --- */}
        <div
          className="row align-items-center"
          data-aos="fade-up"
          data-aos-delay="200"
        >
          {/* Left Image */}
          <div className="col-lg-6 text-center mb-4 mb-lg-0 p-0">
            <img
              src={about3}
              alt="Law Image 1"
              className="img-fluid hover-effect"
            />
          </div>

          {/* Right Content */}
          <div className="col-lg-6">
            <div className="px-5">
              <h2 className="">Nature of Work</h2>
              <p className="mt-3 ">
                Work comprises of professional work mainly relating to real
                estates and commercial laws as under:
              </p>

            <div className="mt-4">
  <div className="row g-3">
    
    {/* Card 1 */}
    <div className="col-6">
      <div
        className="card border-0 shadow-sm text-center p-4 h-100 service-card"
        style={{ cursor: "pointer", borderRadius: "16px" }}
      >
        <div className="mb-3">
          <i className="bi bi-buildings fs-1 text-danger"></i>
        </div>
        <h6 className="fw-bold mb-0">Real Estate</h6>
      </div>
    </div>
{/* Card 4 */}
    <div className="col-6">
      <div
        className="card border-0 shadow-sm text-center p-4 h-100 service-card"
        style={{ cursor: "pointer", borderRadius: "16px" }}
      >
        <div className="mb-3">
          <i className="bi bi-diagram-3 fs-1 text-danger"></i>
        </div>
        <h6 className="fw-bold mb-0">Co-Operative</h6>
      </div>
    </div>

    {/* Card 2 */}
    <div className="col-6">
      <div
        className="card border-0 shadow-sm text-center p-4 h-100 service-card"
        style={{ cursor: "pointer", borderRadius: "16px" }}
      >
        <div className="mb-3">
          <i className="bi bi-bank fs-1 text-danger"></i>
        </div>
        <h6 className="fw-bold mb-0">Litigation</h6>
      </div>
    </div>

    {/* Card 3 */}
    <div className="col-6">
      <div
        className="card border-0 shadow-sm text-center p-4 h-100 service-card"
        style={{ cursor: "pointer", borderRadius: "16px" }}
      >
        <div className="mb-3">
          <i className="bi bi-people-fill fs-1 text-danger"></i>
        </div>
        <h6 className="fw-bold mb-0">Social</h6>
      </div>
    </div>

    
  </div>
</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Homenew;
